import { Reveal } from "@/components/Reveal";
import { BeforeAfterSlider } from "@/components/BeforeAfterSlider";
import { ImageIcon, MoveHorizontal } from "lucide-react";
import { WORK } from "@/data";

const Placeholder = ({ label }) => (
  <div className="relative flex-1 aspect-[4/5] overflow-hidden bg-navy/90">
    <div className="h-full w-full flex flex-col items-center justify-center gap-2 text-ice/30 border border-dashed border-ice/15">
      <ImageIcon size={26} />
      <span className="font-primary uppercase text-[10px] tracking-widest">Photo coming</span>
    </div>
    <span
      className={`absolute top-3 left-3 font-primary uppercase text-[11px] tracking-widest px-3 py-1.5 ${
        label === "After" ? "bg-gold text-navy" : "bg-navy text-ice"
      }`}
    >
      {label}
    </span>
  </div>
);

const WorkCard = ({ item, index }) => {
  const isPair = item.before && item.after;
  const isSingle = !item.before && item.after;
  const aspect = item.orientation === "portrait" ? "aspect-[3/4]" : "aspect-[4/3]";
  return (
    <div data-testid={`work-item-${index}`}>
      {isPair ? (
        <BeforeAfterSlider before={item.before} after={item.after} aspect={aspect} />
      ) : isSingle ? (
        <div className={`relative w-full ${aspect} overflow-hidden bg-navy`}>
          <img src={item.after} alt={item.title} className="h-full w-full object-cover" draggable={false} />
          <span className="absolute top-3 left-3 font-primary uppercase text-[11px] tracking-widest px-3 py-1.5 bg-gold text-navy">
            Finished
          </span>
        </div>
      ) : (
        <div className="flex gap-2 md:gap-3">
          <Placeholder label="Before" />
          <Placeholder label="After" />
        </div>
      )}
      <div className="flex items-start justify-between gap-4 mt-5">
        <div>
          <h3 className="font-primary font-semibold uppercase tracking-tight text-navy text-xl md:text-2xl">
            {item.title}
          </h3>
          <p className="font-body text-navy/70 text-base mt-2 max-w-md">{item.desc}</p>
        </div>
        {isPair && (
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 mt-1 font-primary uppercase text-[10px] tracking-widest text-navy/40">
            <MoveHorizontal size={14} /> Drag
          </span>
        )}
      </div>
    </div>
  );
};

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="bg-ice py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-16">
        <Reveal>
          <p className="font-primary uppercase tracking-[0.3em] text-navy/50 text-xs md:text-sm mb-4">Our Work</p>
          <h2 className="font-primary font-bold uppercase tracking-tighter text-navy text-5xl md:text-7xl leading-[0.9]">
            Before<br />& After
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-body text-navy/70 text-base md:text-lg max-w-sm">
            Real jobs, real transformations. Drag the slider on any photo to reveal the difference.
          </p>
        </Reveal>
      </div>

      <div className="columns-1 md:columns-2 gap-8">
        {WORK.map((item, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1} className="mb-14 break-inside-avoid">
            <WorkCard item={item} index={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
